import { call, put, select } from "redux-saga/effects";
import { actions as managerActions } from "@/reducers/manager";
import { parseError } from "@/utils/utils";
import { handleSagaError } from '@/sagas/index';

const contextStore = (state) => state.main.context;
const cliendDataStore = (state) => state.client.clientInfo;
const idFront = "TC";
const GENERICO = "generico";
const VERSIONS={V2:"2",V3:"3"}
export function* getObd(params) {
  try {
    const { forzarOBD, origen, customerAccountId, version, build, destino, destino2 } =
      params.payload;
    const context = yield select(contextStore);
    let versionCalc = VERSIONS.V3;
    const cliendData = yield select(cliendDataStore);
    // versionCalc = cliendData?.docTypeText==="NIE" ? VERSIONS.V3 : VERSIONS.V2;
    const data = { forzarOBD, destino, destino2 };
    const module = yield call(() =>
      import("@/adabyron/telcol/gestion-de-credenciales/onboarding/enrutado")
    );
    const promise = module.getObd;

    const response = yield call(promise, {
      data,
      context,
      idFront,
      build,
      version: versionCalc,
    });
    //
    if (response) {
      yield put(managerActions.successGetObd(response.datos));
    } else {
      yield put(managerActions.failureGetObd(response));
    }
  } catch (error) {
    const errorParse = parseError(error);
    let reducerFailureAction;
    if (errorParse.parseState) {
      reducerFailureAction = managerActions.failureGetObd(errorParse.obj);
    } else {
      reducerFailureAction = managerActions.failureGetObd(error);
    }
    yield handleSagaError(
      "getObd",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
}

export function* getCompleteOBD(params) {
  try {
    const { code, state, errorDaon, webviews, build, errorJSON } = params.payload;
    let versionCalc = VERSIONS.V3;
    const cliendData = yield select(cliendDataStore);
    // versionCalc = cliendData?.docTypeText==="NIE" ? VERSIONS.V3 : VERSIONS.V2;
    const context = yield select(contextStore);
    const data = {
      code,
      state,
      errorDaon,
      webviews,
      errorJSON,
    };
    let response = null;
    // if (versionCalc === VERSIONS.V2) {
    //   const module = yield call(() =>
    //     import("@gcloud-npm/adabyron.client.gestion-de-credenciales.onboarding.upgrade")
    //   );
    //   const promise = module.obdComplete;
    //   response = yield call(promise, {
    //     data,
    //     context,
    //     idFront,
    //     build,
    //     version: VERSIONS.V2,
    //   });
    // }
    const module = yield call(() =>
        import("@/adabyron/telcol/manager/upgrade")
      );
    const promise = module.obdComplete;
    response = yield call(promise, {
      data,
      context,
      idFront,
      build,
      version: VERSIONS.V3,
    });
    yield put(managerActions.successGetCompleteObd(response?.datos));
  } catch (error) {
    const errorParse = parseError(error);
    let reducerFailureAction;
    if (errorParse.parseState) {
      reducerFailureAction = managerActions.failureGetCompleteObd(errorParse.obj);
    } else {
      reducerFailureAction = managerActions.failureGetCompleteObd(true);
    }
    yield handleSagaError(
      "getCompleteOBD",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );

  }
}

export function* generatePin(params) {
  try {
    const {
      verifiedContactMeanId,
      subscribedLineId,
      securityMediumTypePayload,
      verificarContactoPayload,
      build,
      vulnerableCode,
    } = params.payload;
    const data = {
      verifiedContactMeanId,
      subscribedLineId,
      securityMediumType: securityMediumTypePayload,
      verificarContacto: verificarContactoPayload,
      vulnerableCode,
    };
    const context = yield select(contextStore);
    const module = yield call(() =>
      import("@/adabyron/telcol/gestion-de-credenciales/onboarding/pin/gen")
    );
    const promise = module.pinGenerate;

    const response = yield call(promise, {
      data,
      context,
      idFront,
      build,
      version: "2",
    });
    yield put(managerActions.successGeneratePin(response.datos));
  } catch (error) {
    const errorParse = parseError(error);
    let reducerFailureAction;
    if (errorParse.parseState) {
      const { codigoErrorNegocio } = errorParse.obj.error;

      reducerFailureAction = managerActions.failureGeneratePin(codigoErrorNegocio);
    } else {
      reducerFailureAction = managerActions.failureGeneratePin(GENERICO);
    }
    yield handleSagaError(
      "generatePin",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
    // const reducerFailureAction = managerActions.failureGeneratePin(codigoErrorNegocio);
    // yield handleSagaError(sagaNames.GENERATE_PIN, error, reducerFailureAction);
  }
}

export function* validatePin(params) {
  try {
    const { pinPayload, verificarContactoPayload, build } = params.payload;
    const data = {
      pin: pinPayload,
      verificarContacto: verificarContactoPayload,
    };
    const context = yield select(contextStore);
    const module = yield call(() =>
      import("@/adabyron/telcol/gestion-de-credenciales/onboarding/pin/validar")
    );
    const promise = module.pinValidate;

    const response = yield call(promise, {
      data,
      context,
      idFront,
      build,
      version: "2",
    });
    yield put(managerActions.successValidatePin(response.datos));
  } catch (error) {
    const errorParse = parseError(error);
    let reducerFailureAction;
    if (errorParse.parseState) {
      const { codigoErrorNegocio } = errorParse?.obj?.error;
      if (codigoErrorNegocio) {
        reducerFailureAction = managerActions.failureValidatePin(codigoErrorNegocio);
      } else {
        reducerFailureAction = managerActions.failureValidatePin(GENERICO);
      }
    } else {
      reducerFailureAction = managerActions.failureValidatePin(GENERICO);
    }
    yield handleSagaError(
      "validatePin",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
}

export function* checkObd() {
  try {
    const context = yield select(contextStore);
    const module = yield call(() =>
      import("@/adabyron/telcol/gestion-de-credenciales/onboarding/comprobar")
    );
    const promise = module.checkObd;

    const response = yield call(promise, {
      data: null,
      context,
      idFront,
      build: false,
      version: null,
    });
    if (response) {
      yield put(managerActions.successCheckObd(response.datos));
    } else {
      yield put(managerActions.failureCheckObd(response));
    }
  } catch (error) {
    const errorParse = parseError(error);
    let reducerFailureAction;
    if (errorParse.parseState) {
      const { codigoErrorNegocio } = errorParse.obj.error;
      reducerFailureAction = managerActions.failureCheckObd(codigoErrorNegocio);
    } else {
      reducerFailureAction = managerActions.failureCheckObd(GENERICO);
    }
    yield handleSagaError(
      "checkObd",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
}

export function* redirect(params) {
  const { url } = params.payload;
  try {
    if (url) {
      document.location.href = url;
    }
  } catch (error) {
    yield put(managerActions.failureValidatePin(`ERROR:${error}`));
  }
}

